import { Injectable } from '@angular/core';

import { createDialogServiceBase } from 'tiime-material';

import { Document } from '@models/document';

import { AddFileFromDocumentsDialogComponent } from './add-file-from-documents-dialog.component';

@Injectable({ providedIn: 'root' })
export class AddFileFromDocumentsDialogService extends createDialogServiceBase<Document | null>(
  AddFileFromDocumentsDialogComponent
) {}
